import { useMemo } from 'react';

import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

import { useHouseholdWorkflowTrackersContext } from '../contexts/useHouseholdWorkflowTrackersContext';

/**
 * Returns true while a household workflow tracker of `kind` that is linked to
 * the conversation is queued or started. Returns false when there is no
 * conversation.
 */
export function useIsConversationWorkflowTrackerInProgress(
  conversationId: string | null | undefined,
  kind: WorkflowTrackerKind
): boolean {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  return useMemo(() => {
    if (!conversationId) return false;

    return trackers.some(
      (tracker) =>
        tracker.kind === kind &&
        tracker.conversation?.id === conversationId &&
        (tracker.status === WorkflowTrackerStatus.Queued ||
          tracker.status === WorkflowTrackerStatus.Started)
    );
  }, [trackers, conversationId, kind]);
}
